import React, { Component } from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import customerIcon from "../../../assets/images/pin_home.png"
import driverIcon from "../../../assets/images/pin_motorista.png"
import resaleIcon from "../../../assets/images/pin_revenda.png"

const Maps = withScriptjs(withGoogleMap((props) => {
  const createLatLng = (lat, lng) => ({lat: lat, lng: lng})
  const localizacaoCliente = createLatLng(
    props.localizacaoCliente ? props.localizacaoCliente.latitude : -23.533773,
    props.localizacaoCliente ? props.localizacaoCliente.longitude : -46.62529)
  const localizacaoVendedor = createLatLng(
    props.localizacaoVendedor ? props.localizacaoVendedor.latitude : -23.533773,
    props.localizacaoVendedor ? props.localizacaoVendedor.longitude : -46.62529)

  return (
    <GoogleMap
      ref={(map) => {
        if (!map) return null
        const bounds = new window.google.maps.LatLngBounds()
        const latLngCliente = new window.google.maps.LatLng(localizacaoCliente.lat, localizacaoCliente.lng)
        const latLngVendedor = new window.google.maps.LatLng(localizacaoVendedor.lat, localizacaoVendedor.lng)
        bounds.extend(latLngCliente)
        bounds.extend(latLngVendedor)
        map.fitBounds(bounds)
      }}
      defaultOptions={{
        mapTypeControl: false,
        streetViewControl: false
      }}
    >
      <Marker
        icon={props.tipoPedido === 1 ? driverIcon : resaleIcon}
        position={{
          lat: localizacaoVendedor.lat,
          lng: localizacaoVendedor.lng
        }}>
      </Marker>
      <Marker
        icon={customerIcon}
        position={{
          lat: localizacaoCliente.lat,
          lng: localizacaoCliente.lng
        }}>
      </Marker>
    </GoogleMap>
  )
}))

class MapaPedido extends Component {

  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {

    const { localizacaoVendedor, localizacaoCliente, tipoPedido, zoom  } = this.props

    return(
      <Maps
        localizacaoVendedor={localizacaoVendedor}
        localizacaoCliente={localizacaoCliente}
        tipoPedido={tipoPedido}
        zoom={zoom}
        markInfoIsOpen={false}
        isMarkerShown
        googleMapURL={process.env.REACT_APP_MAPS}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: '200px'  }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    )
  }
}

export default MapaPedido
